export const GFE_DISCLAIMER_URL =
  'https://www.cms.gov/files/document/gfe-and-ppdr-requirements-slides.pdf';
